var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEmailIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 54.5,
    height: 51.5,
    viewBox: "0 0 54.5 51.5",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-144.5 -312.5)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#091119",
    d: "M6.124 32.667A6.132 6.132 0 0 1 0 26.541V8.154v-2.03A6.131 6.131 0 0 1 6.124 0h28.585a6.131 6.131 0 0 1 6.124 6.124v20.417a6.132 6.132 0 0 1-6.124 6.126zm-2.041-6.126a2.044 2.044 0 0 0 2.041 2.043h28.585a2.044 2.044 0 0 0 2.041-2.043v-14.9l-15.341 8.518a2.041 2.041 0 0 1-1.747.112l-.235-.112-15.344-8.523zm16.334-10.5L36.75 6.965v-.841a2.043 2.043 0 0 0-2.041-2.041H6.124a2.043 2.043 0 0 0-2.041 2.041v.84z",
    transform: "translate(144.5 312.5) translate(4.083 8.167) translate(0)"
  }))), /*#__PURE__*/React.createElement("circle", {
    cx: 12.5,
    cy: 12.5,
    r: 12.5,
    fill: "rgba(255,98,98,0.58)",
    transform: "translate(174 339)"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmailIcon);
export default __webpack_public_path__ + "static/media/emailIcon.6fc6100c0fbf018ab57bd640146c0e4c.svg";
export { ForwardRef as ReactComponent };